import config from "../config/config";
import routes from "../Routes/routes";
import {matchPath} from "react-router";

export const parseURL = (href) => {
    var match = href.match(
        // eslint-disable-next-line no-useless-escape
        /^(https?\:)\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/,
    );
    return (
        match && {
            href: href,
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            pathname: match[5],
            search: match[6],
            hash: match[7],
        }
    );
};

/**
 * trackClickEvent:
 * @param url {String} required
 * @return boolean
 */
export const isPWA = (url) => {
    let isPWA = false;
    const redirectUrlObj = new URL(url, config.SHIKSHA_STUDYABROAD_HOME);
    if (redirectUrlObj.hostname === config.SHIKSHA_STUDYABROAD_DOMAIN) {
        const activeRoute = routes.find((route) => matchPath(redirectUrlObj.pathname, route));
        if (activeRoute && activeRoute.path !== "*") {
            isPWA = true;
        }
    }
    return isPWA;
};

export const checkUrlIsExternal = (url) => {
    try {
        const urlObject = new URL(url);
        const hostNameArray = [
            config.SHIKSHA_STUDYABROAD_DOMAIN,
            config.SHIKSHA_HOME.replace("https://", ""),
        ];
        // console.log("hostNameArray", hostNameArray);
        // console.log("urlObject", urlObject);
        if (urlObject?.hostname && !hostNameArray.includes(urlObject.hostname)) {
            return true;
        }
    } catch (_) {
        return false;
    }

    return false;
};

export const getStudyabroadValidHostName = (domain) => {
    return `${domain}${config.SHIKSHA_STUDYABROAD_BASENAME}`;
};
